import React from 'react';
import { connect } from 'react-redux';
import { routes, navigationTabs } from '../../../../routes/constants';
import {
  Navigation,
  AccountIcon,
  AccountContainer,
  AccountHeader,
  NavTabContainer
} from './MobileNavBar.styles';
import { personalDetailsSelectors } from '../../../../tabs/PersonalDetails/ducks';
import MobileNavigationItem from './MobileNavigationItem';
import { sharedSelectors } from '../../../ducks';
import { toTitleCase, trimDash } from '../../../../utilities';
import type { TabFeatureFlags } from '../../../../contracts';
import type { RootState } from '../../../../store/types';

type StateProps = {
  firstName: string;
  tabFeatureFlags: TabFeatureFlags;
};

function MobileNavBar({ firstName, tabFeatureFlags }: StateProps) {
  const firstNameDisplay = toTitleCase(firstName);
  const shouldTruncateFirstName = firstNameDisplay.length > 18;
  const truncatedFirstNameDisplay = () => {
    return shouldTruncateFirstName ? (
      <span>
        {' '}
        {trimDash(firstNameDisplay.substring(0, 18))}
        ...!
      </span>
    ) : (
      <span> {firstNameDisplay}!</span>
    );
  };

  return (
    <Navigation>
      <NavTabContainer>
        <AccountContainer>
          <AccountIcon />
          <AccountHeader>Hello {truncatedFirstNameDisplay()}</AccountHeader>
        </AccountContainer>
        {navigationTabs
          .filter((tab) => {
            const routeDetails = routes[tab.path] || {};
            const { featureFlag } = routeDetails;
            return featureFlag
              ? (tabFeatureFlags[routeDetails.featureFlag as keyof TabFeatureFlags] ?? false)
              : true;
          })
          .map((tab) => (
            <MobileNavigationItem tab={tab} key={tab.path} />
          ))}
      </NavTabContainer>
    </Navigation>
  );
}

const mapStateToProps = (state: RootState) => ({
  firstName: personalDetailsSelectors.getFirstName(state),
  tabFeatureFlags: sharedSelectors.getTabFeatureFlags(state)
});

export default connect(mapStateToProps)(MobileNavBar);
